<template>
  <!--
    Note that using :disable-transition="false" here can lead to unexpected
    behavior when BOTH v-if and v-if-else elements appear in DOM simultaneously
    for a split second, which causes a visual bug.
  -->
  <a-spinner
    v-if="isSpinnerVisible"
    :size="spinnerSize"
    :disable-transition="true"
    class="login-button__spinner"
  />
  <a-button
    v-else-if="!isLoggedIn"
    :id="$options.consts.ACTIVATOR_ID.AUTH"
    :button-style="$options.consts.BUTTON_STYLE.PURPLE"
    :disabled="isPreviewMode"
    class="login-button__btn text-primary-navigation bold"
    @click="openAuthForm"
  >
    <a-icon
      v-if="isIconVisible"
      :icon="$options.consts.ICON.LOG_IN"
      :original="true"
      :no-hover="true"
      :width="16"
      :height="16"
      class="login-button__icon "
    />
    Log In
  </a-button>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { BUTTON_STYLE } from 'shared/AButton/index.vue'
import {
  ACTIVATOR_ID,
  ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID
} from '~/utils/enums/activator-id'
import { MODAL } from '~/components/_modals/AModalWrapper/index.vue'
import * as types from '@/store/mutation-types'
import { propValidator, PROP_TYPES } from '@fmpedia/validators'
import ASpinner from '~/components/_shared/ASpinner/index.vue'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

const SPINNER_MOBILE_SIZE = 25
const SPINNER_DESKTOP_SIZE = 30

export default {
  name: 'ALoginButton',
  components: { ASpinner, AIcon },
  mixins: [hydrationHelpers],
  props: {
    isIconVisible: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  consts: {
    ICON,
    BUTTON_STYLE,
    ACTIVATOR_ID
  },
  computed: {
    ...mapGetters({
      isAuthFormLoaded: 'auth/isAuthFormLoaded',
      isAuthFormLoadingInProgress: 'auth/isAuthFormLoadingInProgress',
      isAuthStatusRequestInProgress: 'auth/isAuthStatusRequestInProgress',
      isLoggedIn: 'auth/isLoggedIn',
      isPreviewMode: 'isPreviewMode'
    }),
    isSpinnerVisible() {
      return (
        this.isAuthFormLoadingInProgress ||
        this.isAuthStatusRequestInProgress ||
        !this.isMounted
      )
    },
    spinnerSize() {
      return this.$_hydrationHelpers_mobileOrDesktopValue(
        SPINNER_MOBILE_SIZE,
        SPINNER_DESKTOP_SIZE
      )
    }
  },
  methods: {
    ...mapMutations({
      setAuthFormLoadingInProgress: `auth/${types.SET_AUTH_FORM_LOADING_IN_PROGRESS}`
    }),
    openAuthForm() {
      if (!this.isAuthFormLoaded) {
        this.setAuthFormLoadingInProgress()
      }

      this.$helper.openModal(MODAL.AUTH_FORM, {
        activatorSelector: ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID[ACTIVATOR_ID.AUTH]
      })
    }
  }
}
</script>

<style lang="scss">
.login-button__icon {
  margin-right: 6px;
}
</style>
